/*global angular*/
var donought = angular.module('doughnut', ['chart.js']);
donought.directive('doughnut', ['$q', 'curriculumManager', function ($q, curriculumManager) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./doughnut.html'),
    replace: true,
    transclude: true,
    scope: {
      show: '@',
      allOnHover: '=',
      type: '@'
    },
    //require: [ '^xyz' ], //requires a controller from the parent scope
    link: function (scope, element, attrs) {
      var chartOptions = {
        segmentShowStroke: false,
        segmentStrokeColor: '#fff',
        segmentStrokeWidth: 2,
        //animations
        animation: false,
        animationSteps: 170,
        animationEasing: 'easeOutBounce',
        animateRotate: false,
        animateScale: false,
        //tooltips
        showTooltips: false,
        tooltipFillColor: '#344154',
        tooltipFontFamily: 'Roboto',
        tooltipFontSize: 13,
        tooltipFontColor: '#fff',
        tooltipYPadding: 8,
        tooltipXPadding: 10,
        tooltipCornerRadius: 2,
        tooltipTitleFontFamily: 'Roboto'
      };

      var getCount = function (field) {
        if (scope.show === 'all') {
          return 1;
        } else if (scope.show === field.key) {
          return 1;
        } else if (scope.show !== field.key) {
          return 0;
        }
      };

      var getChartData = function (fields) {
        var i;
        var chartData = [];
        var result;
        var addChartDataForField = function (field) {
          result = getCount(field);
          chartData.push({
            value: result,
            color: field.color,
            highlight: field.color,
            label: field.title + ' ingevuld'
          });
          chartData.push({
            value: result === 1 ? 0 : 1,
            color: '#ffffff',
            highlight: '#ffffff',
            label: field.title + ' grijs'
          });
        };
        for (i = 0; i < fields.length; i++) {
          addChartDataForField(fields[i]);
        }
        return chartData;
      };


      var recalcCultureChartData = function () {
        var defer = $q.defer();
        var chartData;
        curriculumManager.getCultuurFields().then(function (fields) {
          chartData = getChartData(fields);
          defer.resolve( {
            data: chartData.map(function (a) {return a.value;}),
            colors: chartData.map(function (a) {return a.color;}),
            labels: chartData.map(function (a) {return a.label;})
          });
        });
        return defer.promise;
      };

      var recalcPersonChartData = function () {
        var defer = $q.defer();
        var chartData;
        curriculumManager.getPersoonsFields().then(function (fields) {
          chartData = getChartData(fields);
          defer.resolve({
            data: chartData.map(function (a) {return a.value;}),
            colors: chartData.map(function (a) {return a.color;}),
            labels: chartData.map(function (a) {return a.label;})
          });
        });
        return defer.promise;
      };

      var beforeHover = "";
      element.on('mouseenter', function () {
        if(scope.allOnHover) {
          beforeHover = scope.show;
          scope.show = "all";
          calulate();
        }
      });

      element.on('mouseleave', function () {
        if(scope.allOnHover) {
          scope.show = beforeHover;
          calulate();
        }
      });

      var calulate = function () {
        recalcPersonChartData().then(function (data) {
          scope.personChartData = data;
        });

        recalcCultureChartData().then(function (data) {
          scope.cultureChartData = data;
        });
      }
      calulate();
      scope.$watch('show', function () {
        calulate();
      });

      scope.cultureChartOptions = angular.copy(chartOptions);
      scope.cultureChartOptions.percentageInnerCutout = 70;

      scope.personChartOptions = angular.copy(chartOptions);
      scope.personChartOptions.percentageInnerCutout = 50;
    }
  };
}]);
module.exports = donought;



// WEBPACK FOOTER //
// ./web/js/module/doughnut/doughnut.js